export default {
    loadingMessage: 'Creating authorization...',
    beneficiaryFieldsStepLabel: 'Beneficiary information',
    sponsorFieldsStepLabel: 'Sponsor information',
    IdVerificationStepLabel: 'ID verification',
    title: {
        text: 'New authorization ',
        type: '(Outpatient Care)',
        back: '< Cancel'
    },
    buttons: {
        next: "Next",
        back: "Back",
        cancel: "Cancel",
        end: "Finish"
    },
    beneficiary: {
        title: 'Beneficiary identification',
        description: 'Complete the following information in order to find a beneficiary or dependent:',
        sponsor: 'Sponsor',
        category: 'Category',
        search: {
            methodSelection: 'Choose the search method for the beneficiary',
            btn: 'Search beneficiary'
        }
    },
    sponsors: {
        DO: {
            humano: 'Humano Seguros',
            universal: 'ARS Universal',
            primera: 'ARS primera',
            humanoCategories: {
                global: "Global Health",
                platinum: "Platinum",
                conventional: "Convensional"
            }
        }
    },
    header: {
        memberCodeLabel: 'Member code',
        nameLabel: 'Full name',
        identityDocumentNumberLabel: 'Identification',
        phoneNumberLabel: 'Phone number',
        emailLabel: 'Email'
    }
}

